
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="bbebb910-a448-5b0f-b125-b1d21f757bad")}catch(e){}}();
(function(window, document) {
  'use strict';

  if (!window || !document || !window.HanezzaProductState) return;

  var stateApi = window.HanezzaProductState;
  var dataNode = document.getElementById('hanezza-product-state-data');
  if (!dataNode) return;

  var payload;
  try {
    payload = JSON.parse(dataNode.textContent || '{}');
  } catch (_) {
    return;
  }

  var optionNames = Array.isArray(payload.optionNames) ? payload.optionNames.slice() : [];
  var selectedOptions = payload.selectedOptions && typeof payload.selectedOptions === 'object'
    ? Object.assign({}, payload.selectedOptions)
    : {};
  var variants = (Array.isArray(payload.variants) ? payload.variants : []).map(stateApi.normalizeVariant);
  var labels = payload.labels || {};

  function cloneVariantButtonsToDropLegacyPriceListeners() {
    document.querySelectorAll('.variant-option').forEach(function(button) {
      var clone = button.cloneNode(true);
      button.replaceWith(clone);
    });
  }

  function ensurePriceHooks(container, mobile) {
    if (!container) return;
    var spans = Array.from(container.children).filter(function(node) {
      return node.tagName === 'SPAN';
    });
    var price = spans[0];
    if (!price) {
      price = document.createElement('span');
      price.className = mobile ? 'text-2xl font-bold' : 'text-4xl lg:text-5xl font-bold';
      container.appendChild(price);
    }
    price.setAttribute('data-product-price', '');

    var compare = spans[1];
    if (!compare) {
      compare = document.createElement('span');
      compare.className = mobile
        ? 'text-sm text-text-muted-light line-through'
        : 'text-xl text-text-muted-light line-through font-medium opacity-70';
      compare.hidden = true;
      container.appendChild(compare);
    }
    compare.setAttribute('data-product-compare-price', '');
  }

  function ensureDomHooks() {
    document.querySelectorAll('input[name="id"]').forEach(function(input) {
      input.setAttribute('data-product-variant-id', '');
    });

    document.querySelectorAll('.option-selected-value[data-option-name]').forEach(function(label) {
      label.setAttribute('data-selected-option-label', '');
    });

    document.querySelectorAll('.variant-option[data-option-name][data-option-value]').forEach(function(button) {
      var name = button.getAttribute('data-option-name');
      var value = button.getAttribute('data-option-value');
      button.setAttribute('aria-pressed', selectedOptions[name] === value ? 'true' : 'false');
    });

    ensurePriceHooks(document.getElementById('mobile-product-price'), true);
    ensurePriceHooks(document.getElementById('main-product-price'), false);

    document.querySelectorAll('.stock-status').forEach(function(status) {
      status.setAttribute('data-product-availability', '');
      status.dataset.availableText = labels.available || 'Stokta mevcut.';
      status.dataset.unavailableText = labels.unavailable || 'Stokta yok';
    });
  }

  function syncPurchaseActions(state) {
    var disabled = !state.available;
    document.querySelectorAll('#product-form-mobile button[type="submit"], #product-form-desktop button[type="submit"]').forEach(function(button) {
      var buttonLabel = disabled ? (labels.soldOut || 'Tükendi') : (labels.add || 'Sepete Ekle');
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      button.style.opacity = disabled ? '0.5' : '1';
      button.style.cursor = disabled ? 'not-allowed' : 'pointer';
      var ctaLabel = button.querySelector && button.querySelector('[data-hanezza-cart-label]');
      if (ctaLabel) {
        ctaLabel.textContent = buttonLabel;
        button.setAttribute('data-hanezza-cart-original-label', buttonLabel);
        if (button.getAttribute('data-hanezza-cart-state') !== 'adding' && button.getAttribute('data-hanezza-cart-state') !== 'success') {
          button.setAttribute('data-hanezza-cart-state', 'idle');
        }
      } else {
        button.textContent = buttonLabel;
      }
    });

    document.querySelectorAll('[data-buy-now]').forEach(function(button) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      button.style.opacity = disabled ? '0.5' : '1';
      button.style.cursor = disabled ? 'not-allowed' : 'pointer';
      button.textContent = disabled ? (labels.soldOut || 'Tükendi') : (labels.buyNow || 'Hemen Satın Alın');
    });
  }

  function syncStickyState(state, variant) {
    var desktopImage = document.getElementById('sticky-img');
    var mobileImage = document.getElementById('mobile-atc-img');
    [desktopImage, mobileImage].forEach(function(image) {
      if (image && state.featuredImageSrc) image.src = state.featuredImageSrc;
    });

    var desktopInfo = document.getElementById('sticky-variant-info');
    if (desktopInfo && variant && variant.title) desktopInfo.textContent = 'Seçim: ' + variant.title;

    var mobileInfo = document.getElementById('mobile-atc-variant');
    if (mobileInfo && variant && variant.title) mobileInfo.textContent = variant.title;

    var mobilePrice = document.getElementById('mobile-atc-price');
    if (mobilePrice && state.priceText) mobilePrice.textContent = state.priceText;
  }

  function currentVariant() {
    return stateApi.resolveVariant(variants, optionNames, selectedOptions);
  }

  function applyVariant(variant) {
    if (!variant) return null;
    var state = stateApi.buildProductState(variant, optionNames, selectedOptions);
    stateApi.applyProductState(document, state);
    syncPurchaseActions(state);
    syncStickyState(state, variant);

    if (typeof window.updateSizeAvailability === 'function') {
      window.updateSizeAvailability();
    }

    try {
      document.dispatchEvent(new CustomEvent('hanezza:product-state', { detail: state }));
    } catch (_) {}
    return state;
  }

  // The legacy product section registers a second price-only click listener before
  // deferred assets execute. Replacing only option buttons drops those stale listeners;
  // its main DOMContentLoaded selection handler attaches afterwards and calls the
  // functions below, so one tested state resolver owns the final UI state.
  cloneVariantButtonsToDropLegacyPriceListeners();
  ensureDomHooks();

  window.productVariants = variants;
  window.productOptions = optionNames;
  window.selectedOptions = selectedOptions;
  window.findVariant = currentVariant;
  window.updateVariant = applyVariant;
  window.updatePriceDisplay = applyVariant;

  applyVariant(currentVariant());

  function reapplyCurrentState() {
    var variant = currentVariant();
    if (variant) applyVariant(variant);
  }

  if (window.history && typeof window.history.pushState === 'function') {
    var previousPushState = window.history.pushState;
    window.history.pushState = function() {
      var result = previousPushState.apply(this, arguments);
      window.setTimeout(reapplyCurrentState, 0);
      return result;
    };
  }

  if (window.history && typeof window.history.replaceState === 'function') {
    var previousReplaceState = window.history.replaceState;
    window.history.replaceState = function() {
      var result = previousReplaceState.apply(this, arguments);
      window.setTimeout(reapplyCurrentState, 0);
      return result;
    };
  }

  window.addEventListener('popstate', function() {
    window.setTimeout(reapplyCurrentState, 0);
  });
})(window, document);

//# debugId=bbebb910-a448-5b0f-b125-b1d21f757bad
